export default __webpack_public_path__ + "static/media/auteuil12.59532314.jpg";